__turbopack_context__.v({
  "root": "BlogList-module__15sl8W__root",
});
